// src/pages/Admin/PurchasesAdmin.js
import React, { useEffect, useState } from "react";
import { usePurchases } from "../../hook/usePurchases";
import { HeaderPage } from "../../components/Admin";
import { ModalBasic, DialogBasic } from "../../components/common";
import { useSnackbar } from "notistack";
import { TablePurchases } from "../../components/Admin/Purchases/TablePurchases";
import { AddEditPurchaseForm } from "../../components/Admin/Purchases/forms/AddEditPurchaseForm";
import { PurchaseAttachments } from "../../components/Admin/Purchases/PurchaseAttachments";

export function PurchasesAdmin() {
  const { purchases, loading, getPurchases, newPurchase, editPurchase, removePurchase } = usePurchases();
  const { enqueueSnackbar } = useSnackbar();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [contentModal, setContentModal] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [idItem, setIdItem] = useState(null);

  const refresh = () => getPurchases({ ordering: "-issue_date" });
  useEffect(() => { refresh(); }, []);

  const openCloseModal = () => setShowModal((prev) => !prev);

  const addPurchase = () => {
    setTitleModal("Nueva Compra (Facturada)");
    setContentModal(
      <AddEditPurchaseForm
        onSubmit={newPurchase}
        onClose={openCloseModal}
        onSuccess={() => { refresh(); enqueueSnackbar("Compra creada", { variant: "success" }); }}
      />
    );
    openCloseModal();
  };

  const editPurchaseHandler = (p) => {
    setTitleModal(`Editar Compra #${p.id}`);
    setContentModal(
      <AddEditPurchaseForm
        purchase={p}
        onSubmit={(payload) => editPurchase(p.id, payload)}
        onClose={openCloseModal}
        onSuccess={() => { refresh(); enqueueSnackbar("Compra actualizada", { variant: "success" }); }}
      />
    );
    openCloseModal();
  };

  const onDelete = (p) => { setIdItem(p.id); setOpenDialog(true); };
  const handleCloseDialog = async (confirmed) => {
    if (confirmed) {
      try {
        await removePurchase(idItem);
        enqueueSnackbar("Compra eliminada", { variant: "success" });
        refresh();
      } catch {
        enqueueSnackbar("Error eliminando compra", { variant: "error" });
      }
    }
    setOpenDialog(false);
  };

  const openAttachments = (p) => {
    setTitleModal(`Adjuntos — Compra #${p.id}`);
    setContentModal(<PurchaseAttachments purchase={p} onClose={openCloseModal} />);
    openCloseModal();
  };

  return (
    <>
      <HeaderPage title="Compras (Facturadas)" btnClick={addPurchase} />

      {loading ? <p>Cargando...</p> : (
        <TablePurchases
          purchases={purchases}
          onEdit={editPurchaseHandler}
          onDelete={onDelete}
          onAttachments={openAttachments}
        />
      )}

      <ModalBasic show={showModal} onClose={openCloseModal} title={titleModal} size="large">
        {contentModal}
      </ModalBasic>

      <DialogBasic open={openDialog} onClose={handleCloseDialog} />
    </>
  );
}
